import React from "react";
import "./banner.css";
import { withRouter} from "react-router-dom";
import { directDeepLink, SOURCE_HOME } from "./util";
import bannerimage from "../../assets/images/banner-holi-2026.png";
import { config } from "../../appConfig";
const BANNER_URL = config?.BANNER_URL;


// temp
function Banner(props) {
	let url = new URL(window.location.href);
	const token = url.searchParams.get("token");
	let deepLink = {
		screen: 'UTIL_WEBVIEW',
		paramOne: `${BANNER_URL}/student/?token=${token}`,
		paramTwo: '',
		paramTracking: 'StudentSideBannerClickTracking',
		paramThree: '',
		paramSource: '',
	};
	function bannerClicked(){
		directDeepLink(deepLink, SOURCE_HOME);
	}

  return (
    <div className="layoutBanner">
      <div className="Banner" onClick={bannerClicked}>
		  {/*<Lottie options={bannerAnimation}  />*/}
		  <img src={bannerimage} alt="banner"/>
      </div>
    </div>
  );
}
export default withRouter(Banner);
